import { Box, Typography } from '@mui/material'
import { useGridApiContext } from '@mui/x-data-grid-premium'
import {
  IconPencil,
  IconSparkles,
  IconPinFilled,
  IconGripVertical,
} from '@tabler/icons-react'

import { shadows } from 'src/lib/style'

import Row from '../Row/Row'

const headerSx = {
  width: '100%',
  height: '100%',
  justifyContent: 'space-between',
  cursor: 'pointer',
  transition: 'all 0.2s ease-in-out',
  pr: 1,
  '& .MuiTypography-root': {
    fontSize: '12px',
    fontWeight: 600,
    letterSpacing: '-0.3px',
    flexShrink: 1,
    cursor: 'pointer',
  },
  '& .editable-icon': {
    ml: '4px',
    opacity: 0,
  },
  '& .drag-handle': {
    width: '16px',
    height: '16px',
    opacity: 0,
  },
  '& .pinned-left': {
    transform: 'rotateY(180deg)',
  },
  '& .drag-handle-container': {
    width: '0px',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  '&:hover': {
    background: (theme) => theme.palette.background.default,
    zIndex: 1000,
    position: 'absolute',
    top: '0px',
    left: '-12px',
    width: 'calc(100% + 36px)',
    boxShadow: (theme) => shadows[theme.palette?.mode]?.lg,

    '& .drag-handle, & .editable-icon': {
      opacity: 1,
    },
    '& .drag-handle-container': {
      width: '24px',
    },
  },
}

const DayTableHeader = (params) => {
  const field = params?.field
  const apiRef = useGridApiContext()
  const pinnedLeft = apiRef.current.getPinnedColumns()?.left?.includes(field)
  const pinnedRight = apiRef.current.getPinnedColumns()?.right?.includes(field)

  return (
    params && (
      <Row
        sx={headerSx}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          apiRef.current.showColumnMenu(field)
        }}
      >
        <Row>
          <Box className="drag-handle-container">
            <IconGripVertical
              size={12}
              className="drag-handle"
            />
          </Box>
          <Typography>{params?.colDef?.headerName || params?.field}</Typography>
        </Row>
        <Row>
          {params?.colDef?.editable ? (
            <IconPencil
              size={14}
              className="editable-icon"
            />
          ) : (
            <IconSparkles
              size={14}
              className="editable-icon"
            />
          )}
          {pinnedLeft ? (
            <IconPinFilled
              size={14}
              className="pinned-left pinned-icon"
            />
          ) : null}
          {pinnedRight ? <IconPinFilled size={14} /> : null}
        </Row>
      </Row>
    )
  )
}

export default DayTableHeader
